import { useQuery } from "react-query";

import { getDataStaffBonus } from "~/pages/StaffBonus/GetDataStaffRequests/getDataStaffBonus";

export default function useGetStaffBonus(params: string, enabled: boolean) {
  return useQuery({
    queryKey: ["getDataStaffBonus", params],
    queryFn: () => getDataStaffBonus(params),
    refetchOnWindowFocus: false,
    enabled,
    cacheTime: 0,
  });
}
